import React from 'react';
import styles from './About.module.css';
import { Container } from '../../common/Container';
import { ServiceCard } from './ServiceCard';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';
import clsx from 'clsx';
import { FiTrendingUp, FiCode } from 'react-icons/fi';

export const About: React.FC = () => {
  const [ref, isVisible] = useIntersectionObserver<HTMLElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  const services = [
    {
      id: 'original-apps',
      icon: <FiCode size={40} />,
      title: 'Original Apps',
      description: 'I design and ship iOS apps from scratch — full ownership from product concept through App Store distribution and ongoing iteration.',
      features: [
        'Swift, SwiftUI, TCA architecture',
        'Firebase backend + StoreKit 2',
        'Freemium and subscription monetization',
        'App Store distribution',
        'Post-launch iteration and support',
      ],
    },
    {
      id: 'client-work',
      icon: <FiTrendingUp size={40} />,
      title: 'Client Work',
      description: 'I also work with teams on their existing apps — improving UI/UX, adding features, fixing performance issues, or building something new.',
      features: [
        'UI/UX redesign and modernization',
        'Performance optimization',
        'Feature development and expansion',
        'Code quality and refactoring',
        'iOS native development',
      ],
    },
  ];

  return (
    <section id="about" className={styles.about} ref={ref}>
      <Container>
        <div className={clsx(styles.aboutContent, isVisible && styles.visible)}>
          <div className={styles.header}>
            <h2 className={styles.heading}>What I Build</h2>
            <p className={styles.description}>
              I'm a solo iOS developer who takes apps from concept to App Store. My work includes
              original apps in my own portfolio and client projects for teams who need a strong
              technical partner.
            </p>
          </div>

          <div className={styles.servicesGrid}>
            {services.map((service, index) => (
              <ServiceCard key={service.id} service={service} index={index} />
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};
